import { Head, Link, usePage } from "@inertiajs/react"
import { Header } from "@/components/header"
import { Plus } from "lucide-react"
import type { SharedProps, TagOption } from "@/types"

type Props = {
  trendingTags: TagOption[]
}

export default function Home({ trendingTags }: Props) {
  const { currentUser } = usePage<SharedProps>().props

  return (
    <div className="min-h-screen">
      <Head title="Broken Sounds" />
      <Header />

      <main className="container mx-auto px-4 py-16">
        <div className="max-w-2xl mx-auto text-center">
          <div className="scanlines inline-block mb-4">
            <h1
              className="text-5xl font-mono font-bold tracking-tight glitch"
              data-text="BROKEN SOUNDS"
            >
              BROKEN SOUNDS
            </h1>
          </div>
          <p className="text-muted-foreground text-lg mb-8">
            Free sounds that bite back
          </p>

          <Link
            href={currentUser ? "/samples/new" : "/login"}
            className="group inline-flex items-center gap-3 bg-primary hover:bg-primary/90 text-primary-foreground font-mono text-xl font-bold tracking-wide px-16 py-4 rounded transition-all btn-ghost-shadow"
          >
            <Plus className="h-5 w-5" />
            UPLOAD
          </Link>

          {trendingTags.length > 0 && (
            <div className="mt-24">
              <div className="flex flex-wrap gap-3 justify-center">
                {trendingTags.map((tag) => (
                  <Link key={tag.id} href={`/samples?tag_ids[]=${tag.id}`}>
                    <div
                      className="border border-border hover:border-primary hover:text-primary px-4 py-2 rounded font-mono text-sm transition-colors red-flicker border-flicker-hover"
                      style={{ animationDelay: `${((tag.id * 7) % 12)}s` }}
                    >
                      {tag.name}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}

          <div className="mt-20">
            <Link
              href="/samples"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Browse all samples →
            </Link>
          </div>
        </div>
      </main>
    </div>
  )
}
